"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageLabel = void 0;
var MessageLabel;
(function (MessageLabel) {
    MessageLabel["PASSWORD_CHANGED_SUCCESSFULLY"] = "Password changed successfully";
})(MessageLabel || (exports.MessageLabel = MessageLabel = {}));
//# sourceMappingURL=MessageLabel.js.map